import React, { useState, useContext } from 'react';
import { _l } from 'lib/utils';
import { AppContext } from 'context/AppContext';
import 'antd/dist/antd.css';
import { Row, Col, Form, Input, Button, Checkbox, message } from 'antd';
import { useNavigate } from 'react-router-dom';

import logo from '../images/logo.svg';
import animate_arrow from '../images/animate_arrow.svg';
import { getAccessToken } from 'services/login';

import moment from 'moment';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

// let navigate = useNavigate();

const Login = () => {
    const appContext = useContext(AppContext);

    let navigate = useNavigate();

    const onFinishFailed = () => {
        message.error('Invalid login or password!');
    };

    const onFinish = (values) => {
        const getAccessTokenData = {
            username: values.username,
            password: values.password
        };

        getAccessToken(getAccessTokenData)
            .then((result) => {
                const refreshToken = result.data.refresh;
                const accessToken = result.data.access;
                appContext.setAccessTokenSessionStore(accessToken);
                localStorage.removeItem('activeProject');
                navigate('/');
            })

            .catch((err) => {
                console.log(err);
                onFinishFailed();
            });
    };

    return (
        <>
            <div
                style={{
                    backgroundColor: '#fff',
                    position: 'sticky',
                    top: '0',
                    height: 'auto',
                    zIndex: 1,
                    paddingBottom: '20px',
                    paddingTop: '20px'
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-5">
                            <a href="https://econometrica.com/">
                                <div className="logo-svg">
                                    <img className="logo-svg" src={logo} />
                                </div>
                            </a>
                        </div>
                        <div className="col-7 d-flex justify-content-end pe-0">
                            <a
                                className="button-maroon d-none d-md-block d-lg-none"
                                style={{ margin: '10px 0' }}
                                href="/app/login"
                            >
                                Log In
                            </a>
                            <nav className="navbar navbar-expand-lg navbar-light">
                                <div className="container-fluid pe-0">
                                    <div></div>
                                    <button
                                        className="navbar-toggler collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#navbarSupportedContent"
                                        aria-controls="navbarSupportedContent"
                                        aria-expanded="false"
                                        aria-label="Toggle navigation"
                                    >
                                        <span className="toggler-icon top-bar"></span>
                                        <span className="toggler-icon middle-bar"></span>
                                        <span className="toggler-icon bottom-bar"></span>
                                    </button>
                                    <div
                                        className="collapse navbar-collapse mt-md-1 mt-lg-0 d-none d-lg-block"
                                        id="navbarSupportedContent"
                                    >
                                        <ul className="navbar-nav me-auto mb-lg-0">
                                            <li className="nav-item">
                                                <a
                                                    className="nav-link active"
                                                    aria-current="page"
                                                    href="/"
                                                >
                                                    Home
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    className="nav-link"
                                                    href="/#features"
                                                >
                                                    Features
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    className="nav-link"
                                                    href="/#pricing"
                                                >
                                                    Pricing
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a
                                                    className="nav-link"
                                                    href="/#contact"
                                                >
                                                    Contact Us
                                                </a>
                                            </li>
                                            <li
                                                className="nav-item"
                                                style={{
                                                    marginTop: '6px',
                                                    display: 'block'
                                                }}
                                            >
                                                <a
                                                    className="button-maroon"
                                                    href="/app/login"
                                                >
                                                    Log In
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                    <div className="row ">
                        <div
                            className="collapse navbar-collapse mt-md-1 mt-lg-0 d-lg-none"
                            id="navbarSupportedContent"
                        >
                            <ul className="navbar-nav me-auto mb-lg-0">
                                <li className="nav-item">
                                    <a
                                        className="nav-link active"
                                        aria-current="page"
                                        href="/"
                                    >
                                        Home
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/#features">
                                        Features
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/#pricing">
                                        Pricing
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" href="/#contact">
                                        Contact Us
                                    </a>
                                </li>
                                <li
                                    className="nav-item d-sm-block d-md-none"
                                    style={{ marginTop: '15px' }}
                                >
                                    <a
                                        className="button-maroon "
                                        style={{ margin: '15px 0 5px 0' }}
                                        href="/app/login"
                                    >
                                        Log In
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="form-login-panel"
                style={{
                    backgroundColor: '#e1e9f1',
                    minHeight: 'calc(100vh - 379px)'
                }}
            >
                <Row
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <div
                        style={{
                            color: '#105596',
                            fontSize: '22px',
                            fontFamily: 'Roboto Bold',
                            marginBottom: '10px',
                            marginTop: 50
                        }}
                    >
                        Log In
                    </div>
                </Row>

                <Row
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Col>
                        <Form
                            layout="vertical"
                            name="basic"
                            // labelCol={{ span: 8, }}
                            // wrapperCol={{ span: 16, }}
                            initialValues={{
                                remember: true
                            }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete="off"
                        >
                            <Form.Item
                                label="E-mail"
                                name="username"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your E-mail!'
                                    }
                                ]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                label="Password"
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your password!'
                                    }
                                ]}
                            >
                                <Input.Password />
                            </Form.Item>

                            <Form.Item
                                // wrapperCol={{
                                //   offset: 8,
                                //   span: 16,
                                // }}
                                style={{ textAlign: 'center' }}
                            >
                                <div
                                    style={{
                                        justifyContent: 'left',
                                        display: 'flex',
                                        marginTop: '10px'
                                    }}
                                >
                                    <div>
                                        Forgot password? Then, please{' '}
                                        <span
                                            style={{
                                                cursor: 'pointer',
                                                color: '#105596',
                                                fontWeight: '500'
                                            }}
                                        >
                                            <a
                                                href={`${process.env.REACT_APP_API_URL}/reset-password`}
                                                className="link"
                                            >
                                                reset it here.
                                            </a>
                                            {/* reset it here. */}
                                        </span>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        justifyContent: 'left',
                                        display: 'flex',
                                        marginTop: '10px'
                                    }}
                                >
                                    <div>
                                        Don’t have an account yet? Then, please{' '}
                                        <span
                                            style={{
                                                cursor: 'pointer',
                                                color: '#105596',
                                                fontWeight: '500'
                                            }}
                                        >
                                            <a
                                                href={`${process.env.REACT_APP_API_URL}/#get-started`}
                                                className="link"
                                            >
                                                create one here.
                                            </a>
                                            {/* reset it here. */}
                                        </span>
                                    </div>
                                </div>
                                {/* <Button type="primary" htmlType="submit">
                Log In
              </Button> */}
                                <button
                                    style={{ marginTop: 20, marginBottom: 50 }}
                                    htmltype="submit"
                                    className="button-green-animation"
                                >
                                    Log In
                                    <img
                                        src={animate_arrow}
                                        className="arrow-animation"
                                    />
                                </button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </div>

            <div
            // style={{ position: 'absolute', bottom: 0, width: '100%' }}
            >
                <div
                    style={{
                        backgroundColor: '#F2F2F2',
                        borderTop: '5px solid #60091D'
                    }}
                >
                    <div className="container">
                        <div
                            className="row footer"
                            style={{
                                color: '#3D3F4D',
                                fontSize: '16px',
                                paddingTop: '57px',
                                paddingBottom: '57px'
                            }}
                        >
                            <div className="col-sm-12 col-md-4 mb-5 mb-md-0 ps-md-0 ps-lg-3 d-flex flex-column">
                                <p className="footer-header">HEADQUARTERS</p>
                                <p className="footer-paragraph">
                                    DBA EdgarStat
                                    <br />
                                    5425 Wisconsin Ave., Suite 600
                                    <br />
                                    Chevy Chase, MD, 20815-3577
                                    <br />
                                    USA
                                </p>
                            </div>

                            <div className="col-sm-12 col-md-4 mb-5 mb-md-0 ps-md-0 ps-lg-3 d-flex flex-column">
                                <p className="footer-header ms-lg-5 ms-md-3 ps-lg-3 ps-md-3">
                                    CUSTOMER SUPPORT
                                </p>
                                <p className="footer-paragraph ms-lg-5 ms-md-3 ps-lg-3 ps-md-3">
                                    support@econometrica.com
                                </p>
                            </div>
                            <div className="col-sm-12 col-md-4 ps-md-0 ps-lg-3 d-flex flex-column">
                                <p>
                                    <a
                                        className="footer-paragraph ms-lg-5 ms-md-3 ps-lg-3 ps-md-3"
                                        href="#"
                                    >
                                        Cookie Policy
                                    </a>
                                </p>
                                <p>
                                    <a
                                        className="footer-paragraph ms-lg-5 ms-md-3 ps-lg-3 ps-md-3"
                                        href="privacy-policy"
                                    >
                                        Privacy Policy
                                    </a>
                                </p>
                                <p>
                                    <a
                                        className="footer-paragraph ms-lg-5 ms-md-3 ps-lg-3 ps-md-3"
                                        href="#"
                                    >
                                        Terms Conditions
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ backgroundColor: '#105596' }}>
                    <div className="container">
                        <div
                            className="row"
                            style={{
                                paddingTop: '35px',
                                paddingBottom: '35px',
                                color: 'white',
                                fontSize: '14px'
                            }}
                        >
                            <div className="col-12 text-center footer-footer">
                                © 2022-{moment().format('YYYY')} Econometrica® |
                                All Rights Reserved
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;
